import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createJobRateEntry = createAsyncThunk('createJobRateEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertJobrate`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const updateJobRate = createAsyncThunk('updateJobRate', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=UpdateJobrate`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchJobRateData = createAsyncThunk('fetchJobRateData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getJobRatelist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleJobRate = createAsyncThunk('fetchSingleJobRate', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getJobRatelist&jobId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleJobRate = createAsyncThunk('deleteSingleJobRate', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteJobRate&jobId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const jobrateSlice = createSlice({
    name: 'JobRateData',
    initialState: {
        isLoading: false,
        jobrate: null,
        deleteJobRate: null,
        singleJobRate: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchJobRateData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchJobRateData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.jobrate = action.payload;
        });
        builder.addCase(fetchJobRateData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleJobRate.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleJobRate.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteJobRate = action.payload;
        });
        builder.addCase(deleteSingleJobRate.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleJobRate.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleJobRate.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleJobRate = action.payload;
        });
        builder.addCase(fetchSingleJobRate.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });




    }
});

export default jobrateSlice.reducer;
